import { useTranslation } from 'next-i18next';

import { useAppDispatch } from '@/redux';
import { hidePageProgress, showPageProgress } from '@/redux/slices/gui.slice';
import { addToast } from '@/redux/slices/toast.slice';

export const useExportToCsv = (filename, service, method, ...args) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return async () => {
    try {
      dispatch(showPageProgress());

      const data = args.length > 0 ?
        await service[method](...args) :
        await service[method]();

      if (!data) {
        dispatch(addToast({ msg: t('admin:noContent') }));
        dispatch(hidePageProgress());
        return;
      }

      const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `export_${filename}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      dispatch(hidePageProgress());
    } catch (error) {
      console.error('Export failed:', error);
      dispatch(hidePageProgress());
    }
  };
};
